import "./property_card.sass";
import { Link } from "react-router-dom";
import { formatDecimalNumber } from "../../../services/helpers/formatDecimalNumber";

import property_img from "../../../assets/img/sinimagenunit.png";

function PropertyCard({ gfilter, property }) {
  return (
    <div className="card card-wrapper no-border card-root overflow-hidden">
      {property?.images.length && property?.images[0].url !== null ? (
        <img
          src={property?.images[0].url}
          className="card-img-box no-border no-border-radius"
          alt="Propiedad"
        />
      ) : (
        <img
          src={property_img}
          className="card-img-box no-border no-border-radius"
          alt="Propiedad"
        />
      )}

      <span className="subhead-bold operation total-center">
        En {property?.modality.name === "Venta" ? "Venta" : "Arriendo"}
      </span>
      {/* {property?.type !== null && (
        <span className="feature-type">{property?.type}</span>
      )}
      <div className="info_clearfix">
        <div className="text-right">
          <i className="fas fa-user-secret text-green"></i>
          <span
            className={
              property?.cover_image !== null ? "text-light" : "text-dark"
            }
          >
            {property?.broker}
          </span>
        </div>
      </div> */}

      <div className="card-body p-0">
        <div className='px-4 py-2'>
          <span className="microcopy-bold property-type-label mb-0 d-block">{property?.type.name}</span>
          <Link className='card-title text-decoration-none text-dark' to={{pathname: "/cl/venta/" + property.publication_id, state: gfilter }}>
            <span className="subhead-light">
                  {property?.tittle?.replace(/Ref:\d+\*\*/i, '').slice(0, 45).length ?
                    property?.tittle.replace(/Ref:\d+\*\*/i, '').slice(0, 45)
                    :
                    `${property?.type.name} ${property?.quantity_rooms}D-${property?.quantity_bathrooms}B`
                  }
            </span>
          </Link>
          <span className="microcopy-light mb-0 d-block">{property?.region.name}{ property?.commune.name && `, ${property?.commune.name}` }</span>
        </div>

        <div className='property-grid'>
          <div className='d-flex justify-content-between py-2 px-4'>
            <span className="microcopy-light mb-0">Superficie:</span>
            <span className="microcopy-bold mb-0">{property?.total_area} mt2.</span>
          </div>

          <div className='d-desktop'>
            <div className='d-flex justify-content-between py-2 px-4'>
              <span className="microcopy-light mb-0">Habitaciones:</span>
              <span className="microcopy-bold mb-0">{property?.quantity_rooms}</span>
            </div>
          </div>
          <div className='d-mobile'>
            <div className='d-flex justify-content-between py-2 px-4'>
              <span className="microcopy-light mb-0">Habitaciones:</span>
              <span className="microcopy-bold mb-0">{property?.quantity_rooms}</span>
            </div>
          </div>

          <div className='d-desktop'>
            <div className='d-flex justify-content-between py-2 px-4'>
              <span className="microcopy-light mb-0">Baños:</span>
              <span className="microcopy-bold mb-0">{property?.quantity_bathrooms}</span>
            </div>
          </div>
          <div className='d-mobile'>
            <div className='d-flex justify-content-between py-2 px-4'>
              <span className="microcopy-light mb-0">Baños:</span>
              <span className="microcopy-bold mb-0">{property?.quantity_bathrooms}</span>
            </div>
          </div>

          <div className='d-flex justify-content-between py-2 px-4'>
            <span className="microcopy-light mb-0">Estacionamiento:</span>
            <span className="microcopy-bold mb-0">{property?.parking ? 'Sí' : 'No'}</span>
          </div>
        </div>
      </div>

      <div className="button-grid py-3 px-4">
        <Link to={{pathname: "/cl/venta/" + property.publication_id, state: gfilter }} className='align-self-center'>
          <button className="btn button-style view-property-detail-button microcopy-bold text-white">
            Ver detalles
          </button>
        </Link>
        <div className="d-flex justify-content-end">
          <h2 className="mb-0">
            {property?.price.currency.symbol}{formatDecimalNumber(property?.price.value)}
          </h2>
        </div>
      </div>
    </div>
  );
}

export default PropertyCard;
